import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  AppBar,
  TablePagination,
  Toolbar,
  IconButton,
  Grid,
  MenuItem
} from '@mui/material'
import {
  ArrowBack,
  Save,
  Search,
  Groups
} from '@mui/icons-material'

import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import api from '../../utils/axios'

const tiposGrupo = ['Grupo', 'Associação'];

const FormGrupoAssociacao = () => {
  const navigate = useNavigate()

  const [rows, setRows] = useState([]);
  const [itemEdit, setItemEdit] = useState(null);

  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: {
      nome: '',
      tipo: 'Associação',
      cnpj: '',
      responsavel: '',
      telefone: '',
      email: '',
      endereco: ''
    }
  })

  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [loading, setLoading] = useState(false)

  const [mode, setMode] = useState('');

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    if (mode === "edit" && itemEdit) {
      reset(itemEdit);
    } else if (mode === "create" || mode === "Busca" || !itemEdit) {
      const defaultValues = {
        nome: '',
        tipo: 'Associação',
        cnpj: '',
        responsavel: '',
        telefone: '',
        email: '',
        endereco: ''
      };
      reset(defaultValues);
      setRows([]);
    }
  }, [itemEdit, reset, mode]);

  const handleEdit = (item) => {
    setMode('edit');
    setItemEdit(item);
    reset(item);
  }

  const onSubmit = async (data) => {
    setError('')
    setSuccess('')
    setLoading(true)

    if (!data.id) {
      try {
        const response = await api.put('/gruposassociacoes/save.php', {
          nome: data.nome,
          tipo: data.tipo,
          cnpj: data.cnpj,
          responsavel: data.responsavel,
          telefone: data.telefone,
          email: data.email,
          endereco: data.endereco
        })

        if (response.data.success) {
          setSuccess('Dados salvos com sucesso!')
        } else {
          setError(response.data.message || 'Erro ao salvar dados')
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Erro ao salvar dados')
      } finally {
        setLoading(false)
      }
    } else {
      try {
        const response = await api.put('/gruposassociacoes/update.php', {
          id: data.id,
          nome: data.nome,
          tipo: data.tipo,
          cnpj: data.cnpj,
          responsavel: data.responsavel,
          telefone: data.telefone,
          email: data.email,
          endereco: data.endereco
        })

        if (response.data.success) {
          setSuccess('Dados atualizados com sucesso!')
        } else {
          setError(response.data.message || 'Erro ao atualizar dados')
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Erro ao atualizar dados')
      } finally {
        setLoading(false)
      }
    }
  }

  const onSubmitBusca = async (data) => {
    setError('')
    setSuccess('')
    setLoading(true)
    setMode('');
    setPage(0);

    try {
      const response = await api.put('/gruposassociacoes/list.php', {
        nome: data.nome,
        tipo: data.tipo
      })

      if (response.data.success) {
        setRows(response.data.grupos)
      } else {
        setError(response.data.message || 'Erro ao buscar dados')
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao buscar dados')
    } finally {
      setLoading(false)
    }
  }

  function Row(props) {
    const { row } = props;

    return (
      <TableRow onClick={() => handleEdit(row)} sx={{ cursor: "pointer" }}>
        <TableCell component="th" scope="row">
          {row.nome}
        </TableCell>
        <TableCell align="right">{row.tipo}</TableCell>
        <TableCell align="right">{row.cnpj}</TableCell>
        <TableCell align="right">{row.responsavel}</TableCell>
        <TableCell align="right">{row.telefone}</TableCell>
      </TableRow>
    );
  }

  const Cadastro = () => {
    return (
      <Container sx={{ py: 3 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Groups sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              Grupo/Associação de Produtores
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
              {success}
            </Alert>
          )}

          <form className='admin-form' onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Nome"
                  margin="normal"
                  {...register('nome', {
                    minLength: {
                      value: 3,
                      message: 'Nome deve ter no mínimo 3 caracteres'
                    }
                  })}
                  error={!!errors.nome}
                  helperText={errors.nome?.message}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  select
                  fullWidth
                  label="Tipo"
                  margin="normal"
                  {...register('tipo')}
                >
                  {tiposGrupo.map((tipo) => (
                    <MenuItem key={tipo} value={tipo}>{tipo}</MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="CNPJ"
                  margin="normal"
                  {...register('cnpj')}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Responsável"
                  margin="normal"
                  {...register('responsavel')}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Telefone"
                  margin="normal"
                  {...register('telefone')}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="E-mail"
                  margin="normal"
                  {...register('email')}
                />
              </Grid>

              <Grid item xs={12} md={8}>
                <TextField
                  fullWidth
                  label="Endereço"
                  margin="normal"
                  {...register('endereco')}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  sx={{ mt: 3 }}
                  startIcon={<Save />}
                  disabled={loading}
                >
                  {'Salvar'}
                </Button>

                <Button
                  type={"button"}
                  variant="contained"
                  size="large"
                  onClick={() => setMode('Busca')}
                  sx={{ mt: 3, marginLeft: 2, backgroundColor: '#7469ea' }}
                  startIcon={<KeyboardReturnIcon />}
                  disabled={loading}
                >
                  {'Voltar'}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Container>
    )
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate('/agroeconomia')}
            sx={{ mr: 2 }}
          >
            <ArrowBack />
          </IconButton>
          <Groups sx={{ mr: 2 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Grupos/Associações
          </Typography>
        </Toolbar>
      </AppBar>

      {mode === 'create' || mode === 'edit'
        ?
        <Cadastro />
        :
        <Container sx={{ py: 3 }}>
          <Paper elevation={3} sx={{ p: 4 }}>
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <Groups sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
              <Typography variant="h5" gutterBottom>
                Grupo/Associação de Produtores
              </Typography>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
                {error}
              </Alert>
            )}

            {success && (
              <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
                {success}
              </Alert>
            )}

            <form className='admin-form' onSubmit={handleSubmit(onSubmitBusca)}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Nome"
                    margin="normal"
                    {...register('nome')}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    fullWidth
                    label="Tipo"
                    margin="normal"
                    defaultValue=""
                    {...register('tipo')}
                  >
                    <MenuItem value="">Todos</MenuItem>
                    {tiposGrupo.map((tipo) => (
                      <MenuItem key={tipo} value={tipo}>{tipo}</MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Button
                    type="button"
                    onClick={() => { setItemEdit(null); setMode('create'); }}
                    variant="contained"
                    size="large"
                    sx={{ mt: 3 }}
                    startIcon={<Save />}
                    disabled={loading}
                  >
                    {'Novo'}
                  </Button>

                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{ mt: 3, marginLeft: 2, backgroundColor: '#ccdb00' }}
                    startIcon={<Search />}
                    disabled={loading}
                  >
                    {'Buscar'}
                  </Button>
                </Grid>
              </Grid>
            </form>

            {rows && mode !== 'create' && mode !== 'edit' && <React.Fragment>
              <TableContainer component={Paper}>
                <Table aria-label="grupos table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nome</TableCell>
                      <TableCell align="right">Tipo</TableCell>
                      <TableCell align="right">CNPJ</TableCell>
                      <TableCell align="right">Responsável</TableCell>
                      <TableCell align="right">Telefone</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row) => (
                        <Row key={row.id} row={row} />
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                count={rows.length}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                rowsPerPageOptions={[5, 10, 25]}
                labelRowsPerPage="Linhas por página"
              />
            </React.Fragment>}
          </Paper>
        </Container>
      }
    </Box>
  )
}

export default FormGrupoAssociacao
